import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 34 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.308 9.024a3.707 3.707 0 0 1-2.693-1.178A4.144 4.144 0 0 1 .5 5c0-1.067.401-2.091 1.115-2.846A3.707 3.707 0 0 1 4.308.976C5.318.976 6.286 1.4 7 2.154A4.144 4.144 0 0 1 8.115 5 4.144 4.144 0 0 1 7 7.846a3.707 3.707 0 0 1-2.692 1.178Zm12.692 0a3.706 3.706 0 0 1-2.692-1.178A4.144 4.144 0 0 1 13.192 5c0-1.067.402-2.091 1.116-2.846A3.706 3.706 0 0 1 17 .976c1.01 0 1.978.424 2.692 1.178A4.144 4.144 0 0 1 20.808 5a4.144 4.144 0 0 1-1.116 2.846A3.706 3.706 0 0 1 17 9.024Zm12.692 0A3.706 3.706 0 0 1 27 7.846 4.144 4.144 0 0 1 25.885 5c0-1.067.4-2.091 1.115-2.846A3.706 3.706 0 0 1 29.692.976a3.71 3.71 0 0 1 2.693 1.178A4.144 4.144 0 0 1 33.5 5a4.144 4.144 0 0 1-1.115 2.846 3.707 3.707 0 0 1-2.693 1.178Z",
      fill: "#231F20"
    }, null, -1)
  ]))]))
}
export default { render: render }